import { CcV4Button } from "../../cc-v4/CcV4Button";

/** @deprecated Используйте CcV4Button variant="primary" */
export const BtnPrimaryv4 = ({ onClick, text, footerSize, compact }) => (
  <CcV4Button
    variant="primary"
    onClick={onClick}
    text={text}
    footerSize={footerSize}
    compact={compact}
  />
);
